export const CUSTOM_FIELDS_SET = "CUSTOM_FIELDS_SET";
export const CUSTOM_FIELDS_DELETE = "CUSTOM_FIELDS_DELETE";
export const CUSTOM_FIELDS_CREATE = "CUSTOM_FIELDS_CREATE";
export const CUSTOM_FIELDS_UPDATE = "CUSTOM_FIELDS_UPDATE";
